import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-0"}]]

const IconLetterCSmall = createReactComponent('outline', 'letter-c-small', 'LetterCSmall', __iconNode);

export default IconLetterCSmall;